module.exports = __webpack_public_path__ + "bike_bg.png";